export const ALL_USERS = 'ALL_USERS';

export const EDIT_USERS = 'EDIT_USERS';
